import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { defineComponent } from 'vue'
import TopScreen from '@/components/TopScreen.vue'
import TourSelect from '@/components/TourSelect.vue'
import TourListSelected from '@/components/TourListSelected.vue'
import QuestionnaireFillOut from '@/components/QuestionnaireFillOut.vue'
import QuestionnaireShow from '@/components/QuestionnaireShow.vue'
import Coupon from '@/components/Coupon.vue'
import Greeting from '@/components/Greeting.vue'
import AreaMap from '@/components/AreaMap.vue'
import FreeWifi from '@/components/FreeWifi.vue'
import ArFilter from '@/components/ArFilter.vue'
import Coupons from '@/components/Coupons.vue'
import TopPage from '@/components/TopPage.vue'
import { ScreenName } from '@/types/ScreenName'
import { CouponBannerUser } from '@/types/User'
import { SignatureObject } from '@/types/SignatureObject'
import { QuestionnaireToDisplay } from '@/types/Questionnaire'
import '@fortawesome/fontawesome-free/css/all.min.css';

declare global {
  interface Window {
    qr6d1bjpc11z7c4: string | undefined
  }
}

const __default__ = defineComponent({
  name: 'App',

  components: {
    TopPage,
    TopScreen,
    TourSelect,
    TourListSelected,
    QuestionnaireFillOut,
    QuestionnaireShow,
    Coupon,
    Greeting,
    AreaMap,
    FreeWifi,
    ArFilter,
    Coupons,
  },

  data() {
    return {
      nodeEnvironment: 'development',
      currentComponentName: 'top_screen' as ScreenName,
      hasCheckedForQuestionnaireToDisplay: false,
      questionnaireToDisplay: {
        tourId: null,
        isQuestionnairePresent: false,
        name: '',
      } as QuestionnaireToDisplay,
      signatureObject: {
        signature: '',
        signedData: {},
      } as SignatureObject,
      hasCheckedForFcno: false,
      isCouponBanner: false,
      fcnoMemberNumber: '',
      couponBannerUser: {
        memberNumber: '',
        hasUsedCoupon: false,
      } as CouponBannerUser,
    }
  },
})

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentPath = ref(
  window.location.hash.startsWith('#/') ? window.location.hash.slice(1) : '/'
)

window.addEventListener('hashchange', () => {
  currentPath.value = window.location.hash.startsWith('#/')
    ? window.location.hash.slice(1)
    : '/'
  if (window.location.hash.startsWith('#/')) {
    window.scrollTo(0, 0)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPage, { "page-path": currentPath.value }, null, 8, ["page-path"]))
}
}

})